import http from './http'

export function getPaymentTypes(params = {}) {
  return http.get('payment_type', { params }).then((res) => res.data)
}

export function createPaymentType(data) {
  return http.post('payment_type', data).then((res) => res.data)
}

export function updatePaymentType(id, data) {
  return http.put(`payment_type/${id}`, data).then((res) => res.data)
}

export function deletePaymentType(id) {
  return http.delete(`payment_type/${id}`).then((res) => res.data)
}
